import { atom } from "jotai";

export const tipoDocumento = atom([]);